import {Yii} from "libraries/interfaces/Yii";

const CARD_LABELS = {
    headerFilterCard: Yii.t('wui-sasha-js', 'Modèles de mail'),
    labelInputFilterField: Yii.t('wui-sasha-js', 'Filtrer la liste des modèles'),
    modelsList: Yii.t('wui-sasha-js', 'Liste des modèles'),
    chooseModel: Yii.t('wui-sasha-js', 'Choisir'),
    nextStep: Yii.t('wui-sasha-js', 'Etape suivante'),
    goBack: Yii.t('wui-sasha-js', 'Abandonner')
};

const NOTIFICATIONS = {
    getEmailTemplatesError: Yii.t('wui-sasha-js', 'Une erreur est survenue lors du chargement des templates'),
    getOneEmailTemplate: Yii.t('wui-sasha-js', 'Une erreur est survenue lors du chargement des templates')
};

export const WORDING = {
    ...CARD_LABELS,
    ...NOTIFICATIONS
};